import { render, staticRenderFns } from "./group.vue?vue&type=template&id=10817868&scoped=true"
import script from "./group.vue?vue&type=script&lang=js"
export * from "./group.vue?vue&type=script&lang=js"
import style0 from "./group.vue?vue&type=style&index=0&id=10817868&prod&lang=scss&scoped=true"
import style1 from "./group.vue?vue&type=style&index=1&id=10817868&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10817868",
  null
  
)

export default component.exports